import React from "react";
import {Alert, Box, Chip, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const RequirementCallout = ({rules}) => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.settingsImport.dataSourceCatalog'});

    if (!rules?.length) {
        return null;
    }

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 1.5, mt: 2}}>
            {rules.map((rule) => (
                <Alert
                    key={rule.id}
                    severity="warning"
                    variant="outlined"
                    sx={{borderRadius: 1}}
                >
                    <Typography variant="body2" sx={{mb: rule.uiVariant === 'or-connector' && rule.fieldTitles?.length ? 1 : 0}}>
                        {rule.message}
                    </Typography>
                    {rule.uiVariant === 'or-connector' && rule.fieldTitles?.length > 0 && (
                        <Box sx={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mt: 0.5}}>
                            {rule.fieldTitles.map((title, index) => (
                                <React.Fragment key={title}>
                                    {index > 0 && (
                                        <Chip
                                            label={t('orConnector')}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                fontWeight: 600,
                                                borderStyle: 'dashed',
                                                borderColor: 'divider',
                                                color: 'text.secondary',
                                            }}
                                        />
                                    )}
                                    <Chip
                                        label={title}
                                        size="small"
                                        variant="outlined"
                                        sx={{borderColor: 'divider', fontWeight: 600}}
                                    />
                                </React.Fragment>
                            ))}
                        </Box>
                    )}
                </Alert>
            ))}
        </Box>
    );
};

export default RequirementCallout;
